export const HIDDEN_FIELD_MASK = '***'
